import Header from "./pages/Header";
 import Footer from "./pages/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Service from "./pages/Services"; 
import Contact from "./pages/Contact";

import {Routes,Route } from 'react-router-dom';
function App() {
  return (
     <>
      <Header/> 
      {/* <BrowserRouter> 
      </BrowserRouter> */}
      <Routes>
        <Route path='/' element={<Home/>}  exact />
        <Route path='/about' element={<About/>} exact/>
        <Route path='/service' element={<Service/>} exact/>
        <Route path='/contact' element={<Contact/>} exact/> 
      </Routes>
    <Footer/> 
     </>
  );
}

export default App;
